// extracted by mini-css-extract-plugin
export default {"genreTag":"GenreTag_genreTag__6g92A","disabled":"GenreTag_disabled__BVrbs"};